import { TraitRegistryCategory } from '../../TraitRegistryCategory';
import { TraitTypeCustom } from '../../traitTypes/TraitTypeCustom';
export class TraitRegistryAspectExportImport extends TraitRegistryCategory {
    label = 'Export / Import';
    constructor(parent) {
        super(parent);
        super.init();
    }
    exportaspect = () => new TraitTypeCustom({
        label: 'Exportiere Aspekt',
        multiple: true,
        icon: 'fas fa-upload',
        ser: {
            value: { type: 'aspectexp' }
        },
        /*  aspectsTemplate: {
            core: ['importFilter']
          } */
    });
}
